import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../redux/supportportalLoginSlice';
import './Login.css';
import CustomInput from '../../components/customInput/CustomInput';
import Button from '../../components/button';

function Login() {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleUserIdChange = (e) => {
    setUserId(e.target.value);
    setLoginError('');
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setLoginError('');
  };

  const handleLogin = () => {
    localStorage.removeItem('access_token');
    const credentials = {
      loginUsername: userId,
      password: password
    };
    dispatch(login(credentials))
      .unwrap()
      .then((response) => {
        localStorage.setItem('access_token', response.resdata.access_token);
        navigate('/dashboard');
        window.location.reload();
      })
      .catch((error) => {
        setLoginError('Username or Password is incorrect');
      });
  };

  const handleShowForgotPasswordPage = () => {
    navigate('/login/forgot-password');
  };

  return (
    <div className="login-body">
      <div style={{ width: '30%' }}>
        <div className='login-text'>Login</div>
        <div className='login-container'>
          <div className="input-label-container">
            <span className="item-label">Username</span>
            <CustomInput
              value={userId}
              onChange={handleUserIdChange}
              style={{ width: '100%' }}
            />
          </div>
          <div className="input-label-container">
            <span className="item-label">Password</span>
            <CustomInput
              type='password'
              value={password}
              onChange={handlePasswordChange}
              style={{ width: '100%' }}
            />
            {loginError && <div style={{ color: 'red', marginTop: '5px' }}>{loginError}</div>}
          </div>
          <div
            className='forgot-password'
            onClick={handleShowForgotPasswordPage}
            style={{ cursor: 'pointer' }}
          >
            Forgot Password?
          </div>
          <Button
            style={{ backgroundColor: '#ED1A3D', color: 'white', width: '100%', height: '40px', borderRadius: '10px', border: 'none', cursor: 'pointer' }}
            onClick={handleLogin}
          >
            LOG IN
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Login;